import { Box, type BoxProps } from '@mantine/core';
import type { Cell, Table } from '@tanstack/react-table';

export type TdProps = BoxProps & {
  cell?: Cell<any, unknown>;
  children?: React.ReactNode;
  table: Table<any>;
};

/**
 * Td component
 * This component is used to render the cell of a table.
 *
 * @param cell - The cell instance
 * @param table - The table instance
 * @param children - The children to render inside the header cell
 * @param boxProps - Additional props for the Box component
 */
export const Td: React.FC<TdProps> = ({
  cell,
  children,
  table,
  ...boxProps
}) => (
  <Box
    sx={theme => ({
      padding: theme.other.spacing(2),
      overflow: 'hidden',
    })}
    {...boxProps}
  >
    {children}
  </Box>
);
